<mat-card class="card">
  <div class="page-header">
    <div class="header-left">
      <div class="title">{{ "view_value.detail_meter" | translate }}</div>
      <button mat-icon-button class="icon-close-btn" (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="header-right" *ngIf="isEditMode">
      <div class="title">{{ "view_value.edit_meter" | translate }}</div>
      <button mat-icon-button class="icon-close-btn" (click)="closeEdit()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
  <div class="container">
    <div class="left">
      <div class="section">
        <div class="section-title">
          {{ "view_value.detail_meter" | translate }}
        </div>

        <div class="grid">
          <!-- Meter Info -->
          <div class="field">
            <label>{{ "view_value.meter_name" | translate }}</label>
            <div class="value" [class.changed]="isEdited('name')">
              {{ originalData.name }}
            </div>
          </div>

          <div class="field">
            <label>{{ "view_value.meter_id" | translate }}</label>
            <div class="value" [class.changed]="isEdited('meter_id')">
              {{ originalData.meter_id }}
            </div>
          </div>

          <!-- <div class="field">
            <label>{{ "view_value.module" | translate }}</label>
            <div class="value" [class.changed]="isEdited('module')">
              {{ originalData.module }}
            </div>
          </div> -->

          <div class="field">
            <label>{{ "view_value.sub_meter_id" | translate }}</label>
            <div class="value" [class.changed]="isEdited('sub_meter_id')">
              {{ originalData.sub_meter_id }}
            </div>
          </div>

          <!-- Tenant / Shop Info -->
          <div class="field">
            <label>{{ "view_value.tenant_name" | translate }}</label>
            <div class="value">{{ originalData.tenant_name }}</div>
          </div>

          <!-- Loop / Connection -->
          <div class="field">
            <label>{{ "view_value.loop" | translate }}</label>
            <div class="value" [class.changed]="isEdited('loop_name')">
              {{ originalData.loop_name }}
            </div>
          </div>

          <!-- Panel / Brand / Model -->
          <div class="field">
            <label>{{ "view_value.panel_tier_5" | translate }}</label>
            <div class="value" [class.changed]="isEdited('panel')">
              {{ originalData.panel_tier_5 || "-" }}
            </div>
          </div>

          <div class="field">
            <label>{{ "view_value.brand_name" | translate }}</label>
            <div class="value" [class.changed]="isEdited('brand')">
              {{ originalData.brand_name }}
            </div>
          </div>

          <div class="field">
            <label>{{ "view_value.model" | translate }}</label>
            <div class="value" [class.changed]="isEdited('model')">
              {{ originalData.model }}
            </div>
          </div>

          <!-- Serial Number -->
          <div class="field">
            <label>{{ "view_value.serial_number" | translate }}</label>
            <div class="value" [class.changed]="isEdited('serial_number')">
              {{ originalData.serial_number }}
            </div>
          </div>

          <!-- Tags -->
          <div class="field full">
            <label>{{ "view_value.tag" | translate }}</label>
            <div class="value">
              <ng-container *ngIf="originalData.tags?.length; else noTag">
                <mat-chip-grid #chipGrid>
                  <mat-chip-row *ngFor="let t of originalData.tags">
                    {{ getTagName(t) }}
                  </mat-chip-row>
                </mat-chip-grid>
              </ng-container>
              <ng-template #noTag>-</ng-template>
            </div>
          </div>
        </div>

        <div class="field full">
          <label>{{ "view_value.description" | translate }}</label>
          <div class="value" [class.changed]="isEdited('description')">
            {{ originalData.description }}
          </div>
        </div>
      </div>

      <!-- LOCATION -->
      <div class="section">
        <div class="section-title">
          {{ "view_value.detail_location" | translate }}
        </div>
        <div class="grid">
          <div class="field">
            <label>{{ "view_value.location_tier_1" | translate }}</label>
            <div class="value" [class.changed]="isEdited('location_tier_1')">
              {{ originalData.location_tier_1 }}
            </div>
          </div>
          <div class="field">
            <label>{{ "view_value.location_tier_2" | translate }}</label>
            <div class="value" [class.changed]="isEdited('location_tier_2')">
              {{ originalData.location_tier_2 }}
            </div>
          </div>
          <div class="field">
            <label>{{ "view_value.location_tier_3" | translate }}</label>
            <div class="value" [class.changed]="isEdited('location_tier_3')">
              {{ originalData.location_tier_3 }}
            </div>
          </div>
          <div class="field">
            <label>{{ "view_value.location_tier_4" | translate }}</label>
            <div class="value" [class.changed]="isEdited('location_tier_4')">
              {{ originalData.location_tier_4 }}
            </div>
          </div>
          <div class="field">
            <label>{{ "view_value.location_tier_5" | translate }}</label>
            <div class="value" [class.changed]="isEdited('location_tier_5')">
              {{ originalData.location_tier_5 }}
            </div>
          </div>
        </div>
      </div>

      <div class="actions sticky">
        <button
          mat-raised-button
          color="primary"
          (click)="!isEditMode ? openEdit() : closeEdit()"
        >
          <mat-icon>edit</mat-icon>
          {{ "view_value.edit" | translate }}
        </button>
        <!-- </div> -->
      </div>
    </div>

    <div class="right" *ngIf="isEditMode" [class.open]="isEditMode">
      <form [formGroup]="formMeter" class="form-container">
        <div class="section">
          <div class="section-title">
            {{ "view_value.detail_meter" | translate }}
          </div>
          <div class="grid">
            <!-- Meter Info -->
            <div class="field">
              <label>{{ "view_value.meter_name" | translate }}</label>
              <mat-form-field
                appearance="outline"
                [class.edited]="isEdited('name')"
              >
                <input matInput formControlName="name" />
                <button
                  mat-icon-button
                  matSuffix
                  *ngIf="isEdited('name')"
                  (click)="undoField('name')"
                >
                  <mat-icon>undo</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <div class="field">
              <label>{{ "view_value.meter_id" | translate }}</label>
              <mat-form-field
                appearance="outline"
                [class.edited]="isEdited('meter_id')"
              >
                <input matInput formControlName="meter_id" />
                <button
                  mat-icon-button
                  matSuffix
                  *ngIf="isEdited('meter_id')"
                  (click)="undoField('meter_id')"
                >
                  <mat-icon>undo</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <div class="field">
              <label>{{ "view_value.sub_meter_id" | translate }}</label>
              <mat-form-field
                appearance="outline"
                [class.edited]="isEdited('sub_meter_id')"
              >
                <input matInput formControlName="sub_meter_id" />
                <button
                  mat-icon-button
                  matSuffix
                  *ngIf="isEdited('sub_meter_id')"
                  (click)="undoField('sub_meter_id')"
                >
                  <mat-icon>undo</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <!-- Shop & Loop -->
            <div class="field">
              <label>{{ "view_value.tenant_name" | translate }}</label>
              <mat-form-field appearance="outline">
                <mat-select formControlName="tenant_name">
                  <mat-option>
                    <ngx-mat-select-search
                      [formControl]="tenantSearchCtrl"
                      placeholderLabel="ค้นหา..."
                      noEntriesFoundLabel="ไม่พบข้อมูล"
                    ></ngx-mat-select-search>
                  </mat-option>
                  <mat-option
                    *ngFor="let items of filteredOptionsTenant | async"
                    [value]="items.name"
                  >
                    {{ items.name }}
                  </mat-option>
                </mat-select>

                <button
                  mat-icon-button
                  matSuffix
                  *ngIf="isEdited('tenant_name')"
                  (click)="undoField('tenant_name')"
                >
                  <mat-icon>undo</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <div class="field">
              <label>{{ "view_value.loop" | translate }}</label>
              <mat-form-field
                appearance="outline"
                [class.edited]="isEdited('loop_name')"
              >
                <mat-select formControlName="loop_name">
                  <mat-option>
                    <ngx-mat-select-search
                      [formControl]="loopSearchCtrl"
                      placeholderLabel="ค้นหา..."
                      noEntriesFoundLabel="ไม่พบข้อมูล"
                    ></ngx-mat-select-search>
                  </mat-option>
                  <mat-option
                    *ngFor="let items of filteredLoop$ | async"
                    [value]="items"
                  >
                    {{ items }}
                  </mat-option>
                </mat-select>
                <button
                  mat-icon-button
                  matSuffix
                  *ngIf="isEdited('loop_name')"
                  (click)="undoField('loop_name')"
                >
                  <mat-icon>undo</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <!-- Connection Info -->
            <!-- <div class="field">
          <label>{{ "view_value.conv_ip" | translate }}</label>
          <mat-form-field
            appearance="outline"
            [class.edited]="isEdited('conv_ip')"
          >
            <input matInput formControlName="conv_ip" />
            <button
              mat-icon-button
              matSuffix
              *ngIf="isEdited('conv_ip')"
              (click)="undoField('conv_ip')"
            >
              <mat-icon>undo</mat-icon>
            </button>
          </mat-form-field>
        </div>

        <div class="field">
          <label>{{ "view_value.port" | translate }}</label>
          <mat-form-field
            appearance="outline"
            [class.edited]="isEdited('port')"
          >
            <input matInput formControlName="port" />
            <button
              mat-icon-button
              matSuffix
              *ngIf="isEdited('port')"
              (click)="undoField('port')"
            >
              <mat-icon>undo</mat-icon>
            </button>
          </mat-form-field>
        </div> -->

            <!-- Panel / Brand / Model -->
            <div class="field">
              <label>{{ "view_value.panel_tier_5" | translate }}</label>
              <mat-form-field
                appearance="outline"
                [class.edited]="isEdited('panel')"
              >
                <mat-select formControlName="panel">
                  <mat-option>
                    <ngx-mat-select-search
                      [formControl]="panelSearchCtrl"
                      placeholderLabel="ค้นหา..."
                      noEntriesFoundLabel="ไม่พบข้อมูล"
                    ></ngx-mat-select-search>
                  </mat-option>
                  <mat-option
                    *ngFor="let panel of filteredPanels$ | async"
                    [value]="panel.id"
                  >
                    {{ panel.panel_tier_5 }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="field">
              <label>{{ "view_value.brand_name" | translate }}</label>
              <mat-form-field
                appearance="outline"
                [class.edited]="isEdited('brand')"
              >
                <mat-select formControlName="brand">
                  <mat-option>
                    <ngx-mat-select-search
                      [formControl]="brandSearchCtrl"
                      placeholderLabel="ค้นหา..."
                      noEntriesFoundLabel="ไม่พบข้อมูล"
                    ></ngx-mat-select-search>
                  </mat-option>
                  <mat-option
                    *ngFor="let items of filteredBrands$ | async"
                    [value]="items"
                  >
                    {{ items }}
                  </mat-option>
                </mat-select>

                <button
                  mat-icon-button
                  matSuffix
                  *ngIf="isEdited('brand')"
                  (click)="undoField('brand')"
                >
                  <mat-icon>undo</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <div class="field">
              <label>{{ "view_value.model" | translate }}</label>
              <mat-form-field
                appearance="outline"
                [class.edited]="isEdited('model')"
              >
                <mat-select formControlName="model">
                  <mat-option>
                    <ngx-mat-select-search
                      [formControl]="modelSearchCtrl"
                      placeholderLabel="ค้นหา..."
                      noEntriesFoundLabel="ไม่พบข้อมูล"
                    ></ngx-mat-select-search>
                  </mat-option>
                  <mat-option
                    *ngFor="let items of filteredModels$ | async"
                    [value]="items.id"
                  >
                    {{ items.model }}
                  </mat-option>
                </mat-select>
                <button
                  mat-icon-button
                  matSuffix
                  *ngIf="isEdited('model')"
                  (click)="undoField('model')"
                >
                  <mat-icon>undo</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <!-- Serial Number -->
            <div class="field">
              <label>{{ "view_value.serial_number" | translate }}</label>
              <mat-form-field
                appearance="outline"
                [class.edited]="isEdited('serial_number')"
              >
                <input matInput formControlName="serial_number" />

                <button
                  mat-icon-button
                  matSuffix
                  *ngIf="isEdited('serial_number')"
                  (click)="undoField('serial_number')"
                >
                  <mat-icon>undo</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <!-- Tags -->
            <div class="field full">
              <label>{{ "view_value.tag" | translate }}</label>
              <mat-form-field appearance="outline" class="full">
                <mat-chip-grid #chipGrid>
                  <mat-chip-row
                    *ngFor="let tag of formMeter.value.tags"
                    (removed)="removeTag(tag)"
                  >
                    {{ getTagName(tag) }}
                    <button matChipRemove>x</button>
                  </mat-chip-row>

                  <input
                    placeholder="Add tag"
                    #tagInput
                    [formControl]="tagCtrl"
                    [matAutocomplete]="auto"
                    [matChipInputFor]="chipGrid"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    (matChipInputTokenEnd)="addTagFromAutocomplete($event)"
                  />
                </mat-chip-grid>

                <mat-autocomplete
                  #auto="matAutocomplete"
                  (optionSelected)="selectedTag($event)"
                >
                  <mat-option
                    *ngFor="let tag of filteredTags | async"
                    [value]="tag.name"
                  >
                    {{ tag.name }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>

            <!-- Description -->
            <div class="field full">
              <label>{{ "view_value.description" | translate }}</label>
              <mat-form-field
                appearance="outline"
                class="full"
                [class.edited]="isEdited('description')"
              >
                <textarea matInput formControlName="description"></textarea>

                <button
                  mat-icon-button
                  matSuffix
                  *ngIf="isEdited('description')"
                  (click)="undoField('description')"
                >
                  <mat-icon>undo</mat-icon>
                </button></mat-form-field
              >
            </div>
          </div>
        </div>

        <!-- LOCATION SECTION -->
        <div class="section">
          <div class="section-title">
            {{ "view_value.detail_location" | translate }}
          </div>
          <div class="grid">
            <div class="field">
              <label>{{ "view_value.location_tier_1" | translate }}</label>
              <mat-form-field appearance="outline">
                <mat-select formControlName="location_tier_1">
                  <mat-option>
                    <ngx-mat-select-search
                      [formControl]="locationTier1SearchCtrl"
                      placeholderLabel="ค้นหา..."
                      noEntriesFoundLabel="ไม่พบข้อมูล"
                    ></ngx-mat-select-search>
                  </mat-option>
                  <mat-option
                    *ngFor="let item of filteredlocationTier1$ | async"
                    [value]="item"
                    >{{ item }}</mat-option
                  >
                </mat-select>
                <button
                  mat-icon-button
                  matSuffix
                  *ngIf="isEdited('location_tier_1')"
                  (click)="undoField('location_tier_1')"
                >
                  <mat-icon>undo</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <div class="field">
              <label>{{ "view_value.location_tier_2" | translate }}</label>
              <mat-form-field appearance="outline">
                <mat-select formControlName="location_tier_2">
                  <mat-option>
                    <ngx-mat-select-search
                      [formControl]="locationTier2SearchCtrl"
                      placeholderLabel="ค้นหา..."
                      noEntriesFoundLabel="ไม่พบข้อมูล"
                    ></ngx-mat-select-search>
                  </mat-option>
                  <mat-option
                    *ngFor="let item of filteredlocationTier2$ | async"
                    [value]="item"
                    >{{ item }}</mat-option
                  >
                </mat-select>
                <button
                  mat-icon-button
                  matSuffix
                  *ngIf="isEdited('location_tier_2')"
                  (click)="undoField('location_tier_2')"
                >
                  <mat-icon>undo</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <div class="field">
              <label>{{ "view_value.location_tier_3" | translate }}</label>
              <mat-form-field appearance="outline">
                <mat-select formControlName="location_tier_3">
                  <mat-option>
                    <ngx-mat-select-search
                      [formControl]="locationTier3SearchCtrl"
                      placeholderLabel="ค้นหา..."
                      noEntriesFoundLabel="ไม่พบข้อมูล"
                    ></ngx-mat-select-search>
                  </mat-option>
                  <mat-option
                    *ngFor="let item of filteredlocationTier3$ | async"
                    [value]="item"
                    >{{ item }}</mat-option
                  >
                </mat-select>
                <button
                  mat-icon-button
                  matSuffix
                  *ngIf="isEdited('location_tier_3')"
                  (click)="undoField('location_tier_3')"
                >
                  <mat-icon>undo</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <div class="field">
              <label>{{ "view_value.location_tier_4" | translate }}</label>
              <mat-form-field appearance="outline">
                <mat-select formControlName="location_tier_4">
                  <mat-option>
                    <ngx-mat-select-search
                      [formControl]="locationTier4SearchCtrl"
                      placeholderLabel="ค้นหา..."
                      noEntriesFoundLabel="ไม่พบข้อมูล"
                    ></ngx-mat-select-search>
                  </mat-option>
                  <mat-option
                    *ngFor="let item of filteredlocationTier4$ | async"
                    [value]="item"
                    >{{ item }}</mat-option
                  >
                </mat-select>

                <button
                  mat-icon-button
                  matSuffix
                  *ngIf="isEdited('location_tier_4')"
                  (click)="undoField('location_tier_4')"
                >
                  <mat-icon>undo</mat-icon>
                </button>
              </mat-form-field>
            </div>
            <div class="field">
              <label>{{ "view_value.location_tier_5" | translate }}</label>
              <mat-form-field appearance="outline">
                <mat-select formControlName="location_tier_5">
                  <mat-option>
                    <ngx-mat-select-search
                      [formControl]="locationTier5SearchCtrl"
                      placeholderLabel="ค้นหา..."
                      noEntriesFoundLabel="ไม่พบข้อมูล"
                    ></ngx-mat-select-search>
                  </mat-option>
                  <mat-option
                    *ngFor="let item of filteredlocationTier5$ | async"
                    [value]="item"
                    >{{ item }}</mat-option
                  >
                </mat-select>
                <button
                  mat-icon-button
                  matSuffix
                  *ngIf="isEdited('location_tier_5')"
                  (click)="undoField('location_tier_5')"
                >
                  <mat-icon>undo</mat-icon>
                </button>
              </mat-form-field>
            </div>
          </div>
        </div>
      </form>
      <!-- Actions -->
      <div class="actions space-between">
        <button
          mat-stroked-button
          color="warn"
          (click)="onDeleteMeter()"
          class="warn-outline-btn"
          matTooltip="Delete"
        >
          <mat-icon>delete</mat-icon>
          {{ "view_value.delete_meter" | translate }}
        </button>
        <div class="action-right">
          <button mat-button (click)="undoAll()" [disabled]="!isChanged">
            <mat-icon>history</mat-icon> {{ "view_value.reset" | translate }}
          </button>
          <button
            mat-raised-button
            color="primary"
            (click)="openConfirm()"
            [disabled]="!isChanged"
          >
            <mat-icon>save_as</mat-icon>
            {{ "view_value.save" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</mat-card>
